module.exports = __webpack_public_path__ + "img/news.8cf0f2df.svg";